import { z } from "zod";

// Types
export type SiteInfoSchema = {
  id: number;
  name: string;
  occupancy: number;
  rerun1: number;
  rerun2: number;
  rerun3: number;
  duration: number;

};


export const SiteSchema = z.object({
  siteId: z.string().uuid(),
  name: z.string().optional().nullable(),
  selected: z.boolean().default(false).optional(),
  orderId: z.string().uuid()
})
